"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZoom = exports.setZoom = exports.constrainToBounds = exports.isOffScreenXY = exports.isOffScreen = exports.setCameraXY = exports.update = exports.applyCamY = exports.applyCamX = exports.getCenterXY = exports.getCenter = exports.calculateGameWorldBounds = exports.easeToCenterOn = exports.centerOn = exports.getGameBounds = exports.getGamePositionToUiPosition = exports.getUiPositionToGamePosition = exports.getAdjustedMousePosition = exports.getUiMousePosition = exports.get = void 0;
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageCamera_mover_sidecar_1 = require("@voyage/camera/voyageCamera_mover-sidecar");
var voyageCamera_shaker_sidecar_1 = require("@voyage/camera/voyageCamera_shaker-sidecar");
var voyageCamera_zoomer_sidecar_1 = require("@voyage/camera/voyageCamera_zoomer-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        setCameraXY(-200, -200);
    }
    return _obj;
}
exports.get = get;
function create() {
    var bounds = 128 * 20;
    // let bounds = 0
    var obj = {
        zoom: 1,
        cameraX: 0,
        cameraY: 0,
        bounds: {
            x: -bounds,
            y: -bounds,
            w: 100 * 32 + bounds * 2,
            h: 100 * 32 + bounds * 2,
        },
        gws: { x: 0, y: 0 },
        gwe: { x: 0, y: 0 },
    };
    return obj;
}
function getUiMousePosition() {
    var s = common_sidecar_1.common.getPhaserScene();
    var mx = s.input.mousePointer.x;
    var my = s.input.mousePointer.y;
    return { mx: mx, my: my };
}
exports.getUiMousePosition = getUiMousePosition;
function getAdjustedMousePosition() {
    var s = common_sidecar_1.common.getPhaserScene();
    var mx = s.input.mousePointer.x;
    var my = s.input.mousePointer.y;
    return getUiPositionToGamePosition(mx, my);
}
exports.getAdjustedMousePosition = getAdjustedMousePosition;
function getUiPositionToGamePosition(uix, uiy) {
    var obj = get();
    var zoom = getZoom();
    var gx = (uix + obj.cameraX) / zoom;
    var gy = (uiy + obj.cameraY) / zoom;
    return { x: gx, y: gy };
}
exports.getUiPositionToGamePosition = getUiPositionToGamePosition;
function getGamePositionToUiPosition(gx, gy) {
    var obj = get();
    var zoom = getZoom();
    var mx = gx * zoom - obj.cameraX;
    var my = gy * zoom - obj.cameraY;
    return { x: mx, y: my };
}
exports.getGamePositionToUiPosition = getGamePositionToUiPosition;
function getGameBounds() {
    var scale = common_sidecar_1.common.getPhaserScene().sys.game.scale;
    return { width: scale.width, height: scale.height };
}
exports.getGameBounds = getGameBounds;
function centerOn(x, y) {
    var obj = get();
    var gb = getGameBounds();
    setCameraXY(x * obj.zoom - gb.width / 2, y * obj.zoom - gb.height / 2);
}
exports.centerOn = centerOn;
function easeToCenterOn(x, y, strength) {
    if (strength === void 0) { strength = 1 / 60; }
    var obj = get();
    var gb = getGameBounds();
    var xp = mathUtils_sidecar_1.mathUtils.lerp(obj.cameraX, x * obj.zoom - gb.width / 2, strength);
    var yp = mathUtils_sidecar_1.mathUtils.lerp(obj.cameraY, y * obj.zoom - gb.height / 2, strength);
    setCameraXY(xp, yp);
}
exports.easeToCenterOn = easeToCenterOn;
function calculateGameWorldBounds() {
    var uib = getGameBounds();
    var gws = getUiPositionToGamePosition(0, 0);
    var gwe = getUiPositionToGamePosition(uib.width, uib.height);
    var obj = get();
    obj.gws = gws;
    obj.gwe = gwe;
}
exports.calculateGameWorldBounds = calculateGameWorldBounds;
function getCenter() {
    var obj = get();
    var gb = getGameBounds();
    var x = obj.cameraX + gb.width / 2 / obj.zoom;
    var y = obj.cameraY + gb.height / 2 / obj.zoom;
    return { x: x, y: y };
}
exports.getCenter = getCenter;
var getCenterXY = function () {
    var obj = get();
    var gb = getGameBounds();
    return {
        x: (obj.cameraX + gb.width / 2) / obj.zoom,
        y: (obj.cameraY + gb.height / 2) / obj.zoom, // / data.zoom,
    };
};
exports.getCenterXY = getCenterXY;
var applyCamX = function (x) {
    var obj = get();
    return x * obj.zoom - obj.cameraX;
};
exports.applyCamX = applyCamX;
var applyCamY = function (y) {
    var obj = get();
    return y * obj.zoom - obj.cameraY;
};
exports.applyCamY = applyCamY;
function update(onUpdate) {
    if (onUpdate === void 0) { onUpdate = function (obj) { }; }
    var obj = get();
    voyageCamera_shaker_sidecar_1.voyageCamera_shaker.update();
    voyageCamera_mover_sidecar_1.voyageCamera_mover.update(obj);
    voyageCamera_zoomer_sidecar_1.voyageCamera_zoomer.update();
    if (onUpdate) {
        onUpdate(obj);
    }
    _updateLayers();
    // let ap = common.getPhaserScene().game.input.activePointer
}
exports.update = update;
function _updateLayers() {
    var obj = get();
    var layers = voyageLayers_sidecar_1.voyageLayers.getLayersOnMainCamera();
    var gs = voyageCamera_shaker_sidecar_1.voyageCamera_shaker.get();
    // Floor to help with spaces between sprites
    var cx = Math.floor(obj.cameraX + gs.shakeX); // + 0.01
    var cy = Math.floor(obj.cameraY + gs.shakeY);
    // console.log('klayers?', layers.length)
    imports_1.l.forEach(layers, function (c) {
        c.x = -cx;
        c.y = -cy;
    });
}
function setCameraXY(x, y) {
    var obj = get();
    var bounded = constrainToBounds(x, y, obj.bounds);
    obj.cameraX = bounded.x;
    obj.cameraY = bounded.y;
    _updateLayers();
    calculateGameWorldBounds();
}
exports.setCameraXY = setCameraXY;
function isOffScreen(sprite, tolerance) {
    if (tolerance === void 0) { tolerance = 150; }
    return isOffScreenXY(sprite.x, sprite.y, tolerance);
    // let gb = getGameBounds()
    // let obj = get()
    // // TODO: width / 2?
    // if (
    //   sprite.x + sprite.width * sprite.scale + tolerance < 0 + obj.cameraX ||
    //   sprite.x - sprite.width * sprite.scale - tolerance > gb.width + obj.cameraX
    // ) {
    //   return true
    // }
    // if (
    //   sprite.y + sprite.height * sprite.scale + tolerance < 0 + obj.cameraY ||
    //   sprite.y - sprite.height * sprite.scale - tolerance >
    //     gb.height + obj.cameraY
    // ) {
    //   return true
    // }
    // return false
}
exports.isOffScreen = isOffScreen;
function isOffScreenXY(x, y, tolerance) {
    // let gb = getGameBounds()
    var obj = get();
    if (x < obj.gws.x - tolerance) {
        return true;
    }
    if (y < obj.gws.y - tolerance) {
        return true;
    }
    if (x > obj.gwe.x + tolerance) {
        return true;
    }
    if (y > obj.gwe.y + tolerance) {
        return true;
    }
    // if (
    //   y + tolerance < 0 + obj.cameraY ||
    //   y - tolerance > gb.height + obj.cameraY
    // ) {
    //   return true
    // }
    return false;
}
exports.isOffScreenXY = isOffScreenXY;
function constrainToBounds(x, y, bounds) {
    var ix = x;
    var iy = y;
    var gb = getGameBounds();
    var zoom = get().zoom;
    var bx = bounds.x * zoom;
    var by = bounds.y * zoom;
    if (ix < bx) {
        ix = bx;
    }
    if (iy < by) {
        iy = by;
    }
    var bw = bounds.w * zoom;
    var br = bx + bw - gb.width;
    if (gb.width > bw) {
        br += (gb.width - bw) / 2;
    }
    if (ix > br) {
        ix = br;
    }
    var bh = bounds.h * zoom;
    var bb = by + bh - gb.height;
    if (gb.height > bh) {
        bb += (gb.height - bh) / 2;
    }
    if (iy > bb) {
        iy = bb;
    }
    x = ix;
    y = iy;
    return { x: x, y: y };
}
exports.constrainToBounds = constrainToBounds;
function setZoom(newZoom) {
    var obj = get();
    if (newZoom === obj.zoom) {
        return;
    }
    var oldZoom = obj.zoom;
    var isZoomIn = newZoom > oldZoom;
    var zoomDelta = newZoom - oldZoom;
    // console.log('camera', 'set zoom', obj.zoom, newZoom, zoomDelta)
    var gb = getGameBounds();
    var center = exports.getCenterXY();
    // console.log('camera', 'c1', center.x, center.y)
    // let cx = obj.cameraX + gb.width / 2 / obj.zoom
    // let cy = obj.cameraY + gb.height / 2 / obj.zoom
    var mou = getAdjustedMousePosition();
    var sc = common_sidecar_1.common.getPhaserScene();
    obj.zoom = newZoom;
    imports_1.l.forEach(voyageLayers_sidecar_1.voyageLayers.getLayersOnMainCamera(), function (c) {
        c.scale = newZoom;
    });
    centerOn(center.x, center.y);
    center = exports.getCenterXY();
    // console.log('camera', 'c2', center.x, center.y)
    // centerOn(cx, cy)
    // if (zoomDelta > 0) {
    //   let oldWidth = (1 / oldZoom) * gb.width
    //   let oldHeight = (1 / oldZoom) * gb.height
    //   console.log('camera', 'zoom in', oldWidth, oldHeight)
    //   setCameraXY(obj.cameraX + oldWidth / 4, obj.cameraY + oldHeight / 4)
    //   // centerOn(mou.x, mou.y)
    //   // setCameraXY(obj.cameraX + gb.width / 2, obj.cameraY + gb.height / 2)
    // }
    // if (zoomDelta < 0) {
    //   let oldWidth = (1 / oldZoom) * gb.width
    //   let oldHeight = (1 / oldZoom) * gb.height
    //   setCameraXY(obj.cameraX - oldWidth / 4, obj.cameraY - oldHeight / 4)
    // }
    // if (zoomDelta < 0) {
    //   setCameraXY(obj.cameraX - gb.width / 2, obj.cameraY - gb.height / 2)
    // }
    // if (isZoomIn) {
    //   //centerOn(mou.x, mou.y)
    // }
    //sc.cameras.main.setZoom(zoom)
    // calculateGameWorldBounds()
}
exports.setZoom = setZoom;
function getZoom() {
    return get().zoom;
}
exports.getZoom = getZoom;
